import { Zap, Printer } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Poster() {
  const { settings } = useSite();
  const btc = settings?.btc || "";
  const url = typeof window !== "undefined" ? window.location.origin : "";

  return (
    <main className="min-h-screen py-16 flex flex-col items-center px-4">
      <div className="no-print mb-10 flex flex-col items-center gap-4 text-center max-w-xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400">Launch Material</p>
        <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl">Printable funding poster</h1>
        <p className="text-sm text-slate-400 leading-relaxed">
          An A4-ready flyer carrying the mission, the goal, and your Bitcoin QR. Print it,
          pin it, photograph it, drop it in group chats.
        </p>
        <button
          onClick={() => window.print()}
          data-testid="poster-print-btn"
          className="flex items-center gap-2 bg-amber-400 text-[#07090E] font-semibold text-sm rounded-full px-7 py-3.5 hover:bg-amber-300 transition-colors"
        >
          <Printer className="w-4 h-4" /> Print or save as PDF
        </button>
      </div>

      <div
        id="poster-flyer"
        data-testid="poster-flyer"
        className="bg-white text-slate-900 rounded-2xl shadow-2xl w-[210mm] max-w-full aspect-[210/297] p-[16mm] flex flex-col"
      >
        <div className="flex items-center justify-between border-b-2 border-slate-900 pb-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 bg-slate-900 rounded-md flex items-center justify-center">
              <Zap className="w-5 h-5 text-amber-400" />
            </span>
            <div>
              <p className="font-display font-extrabold text-xl tracking-tight leading-none">SOVERTECH</p>
              <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500 mt-1">Research Fund — Est. 2026</p>
            </div>
          </div>
          <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500 text-right">
            Open research<br />On-chain funding
          </p>
        </div>

        <div className="mt-10">
          <h2 className="font-display font-extrabold tracking-tight text-[42pt] leading-[1.02]">
            Fund the hardware.<br />Build the sovereign<br />future.
          </h2>
          <p className="mt-6 text-[11pt] leading-relaxed text-slate-600 max-w-[150mm]">
            Atomic-scale fabrication, funded entirely on-chain. Help secure the
            production-grade multi-tip atomic deposition printer — depositing
            carbon-hydrogen-gold structural lattices, GaN neural pathways, and
            carbon-nanotube muscle hinges in a single unified build.
          </p>
          <p className="mt-4 font-mono text-[9pt] uppercase tracking-[0.2em] text-slate-500">
            No VCs · No fiat · No gatekeepers
          </p>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center py-8">
          {btc && (
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=520x520&margin=0&data=bitcoin:${btc}`}
              alt="Bitcoin donation QR code"
              data-testid="poster-qr"
              className="w-[72mm] h-[72mm] border-4 border-slate-900 rounded-lg"
            />
          )}
          <p className="mt-4 font-mono text-[10pt] font-bold uppercase tracking-[0.3em]">Scan to send Bitcoin</p>
          <p className="mt-2 font-mono text-[8.5pt] text-slate-600 break-all text-center max-w-[160mm]">{btc}</p>
        </div>

        <div className="border-t-2 border-slate-900 pt-5 flex items-end justify-between">
          <div>
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">Funding target</p>
            <p className="font-display font-extrabold text-[26pt] leading-none mt-1">$1,750,000</p>
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500 mt-1">in BTC — hardware acquisition fund</p>
          </div>
          <div className="text-right">
            <p className="font-mono text-[9pt] font-bold break-all max-w-[90mm]">{url}</p>
            <p className="mt-2 text-[9pt] text-slate-600">Every white paper free to read.<br />Every satoshi builds the machine.</p>
          </div>
        </div>
      </div>
    </main>
  );
}
